module.exports = __webpack_public_path__ + "img/32_fineStaff_yl.c95d687a.png";